export default __webpack_public_path__ + "static/media/Anthony-Adkins.ca4e42a7.jpg";